import { render, staticRenderFns } from "./NotModule.vue?vue&type=template&id=abcb1298&scoped=true&"
import script from "./NotModule.vue?vue&type=script&lang=js&"
export * from "./NotModule.vue?vue&type=script&lang=js&"
import style0 from "./NotModule.vue?vue&type=style&index=0&id=abcb1298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcb1298",
  null
  
)

export default component.exports